import { motion } from 'framer-motion'

// 12 enterprise integrations. Logos via simpleicons CDN — same source the
// MCP gateway uses for the in-app provider catalog.
const providers = [
  { name: 'Jira', icon: 'jira', color: '#0052CC' },
  { name: 'GitHub', icon: 'github', color: '#FFFFFF' },
  { name: 'GitLab', icon: 'gitlab', color: '#FC6D26' },
  { name: 'Bitbucket', icon: 'bitbucket', color: '#2684FF' },
  { name: 'Confluence', icon: 'confluence', color: '#172B4D' },
  { name: 'Postgres', icon: 'postgresql', color: '#336791' },
  { name: 'Jenkins', icon: 'jenkins', color: '#D33833' },
  { name: 'Slack', icon: 'slack', color: '#4A154B' },
  { name: 'SAP', icon: 'sap', color: '#0FAAFF' },
  { name: 'AWS', icon: 'amazonwebservices', color: '#FF9900' },
  { name: 'Azure DevOps', icon: 'azuredevops', color: '#0078D7' },
  { name: 'Salesforce', icon: 'salesforce', color: '#00A1E0' },
]

export function Integrations() {
  return (
    <section
      id="integrations"
      className="relative overflow-hidden bg-gradient-to-b from-zinc-950 via-black to-zinc-950 py-24 sm:py-32"
    >
      {/* Subtle ambient glow */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-96 w-96 -translate-x-1/2 rounded-full bg-cyan-500/10 blur-[100px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          className="mx-auto max-w-2xl text-center"
        >
          <p className="font-mono text-xs uppercase tracking-widest text-cyan-400">
            // integrations
          </p>
          <h2 className="mt-4 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Pre-wired into your stack
          </h2>
          <p className="mt-4 text-lg text-white/70">
            Connect once at the workspace level. Every team in your tenant gets the same
            tools. Tenant-scoped, encrypted at rest with per-tenant Fernet keys, revoked
            on logout.
          </p>
        </motion.div>

        {/* Provider grid — single fade on the container, CSS-only hover on
         * tiles. Cheaper than 12 individual framer-motion subscriptions. */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-40px' }}
          transition={{ duration: 0.4 }}
          className="mx-auto mt-16 grid max-w-5xl grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6"
        >
          {providers.map((p) => (
            <div
              key={p.name}
              className="group relative flex aspect-square flex-col items-center justify-center gap-3 rounded-xl border border-white/10 bg-white/[0.02] p-4 transition hover:-translate-y-1 hover:border-white/20 hover:bg-white/[0.05]"
            >
              <img
                src={`https://cdn.simpleicons.org/${p.icon}/${p.color.replace('#', '')}`}
                alt={p.name}
                className="h-10 w-10 transition-transform group-hover:scale-110"
                loading="lazy"
              />
              <span className="font-mono text-[11px] text-white/70 group-hover:text-white/90">
                {p.name}
              </span>
            </div>
          ))}
        </motion.div>

        {/* Trust line */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mx-auto mt-12 max-w-xl text-center font-mono text-xs text-white/60"
        >
          $ testops integrations list <span className="text-emerald-300">→ 12 active</span>{' '}
          <span className="text-white/40">·</span>{' '}
          <span className="text-cyan-300">more shipping every release</span>
        </motion.p>
      </div>
    </section>
  )
}
